<template>
  <v-container grid-list-md fluid>
    <v-layout align-center justify-space-around wrap>
      <v-flex md12>
        
        <v-toolbar color="primary" dark dense>
          <v-toolbar-title>Images</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card v-if="image">
          <v-card-title>
            <v-btn text icon color="primary" @click.prevent="openImagesPage()"> 
              <v-icon dark>arrow_back</v-icon>
            </v-btn>
            <h4> {{ imageid }} </h4>
            <v-spacer></v-spacer>
            <v-btn small text color="primary" :loading="snack" :disabled="snack || image.status != imageStatus().DONE || image.invalid" @click.prevent="callVerifyImage()">
              <v-icon dark left>verified</v-icon>
              Verify
            </v-btn>
            <v-btn small text color="primary" :loading="snack" :disabled="snack || image.status != imageStatus().DONE || image.invalid" @click.prevent="downloadImage()">
              <v-icon dark left>cloud_download</v-icon>
              Download
            </v-btn>
            <v-btn small text color="red" :loading="snack" :disabled="snack || image.status == imageStatus().PENDING || image.status == imageStatus().RUNNING" @click.prevent="confirmDelete = true">
              <v-icon dark left>delete</v-icon>
              Delete
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <v-layout wrap>
            <v-flex md6>
              <v-simple-table dense>
                <tbody>
                  <tr>
                    <td>ID</td>
                    <td>{{ image.imageid }}</td>
                  </tr>
                  <tr>
                    <td>Type</td>
                    <td> {{ deviceTypeToString(image.type) }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Template ID</td>
                    <td @click="openTemplatePage(image.templateid)" :style="{cursor:'pointer', color:'#00e', 'text-decoration-line':'underline'}" v-if="aaaaccess(user)"> {{ image.templateid }}</td>
                    <td v-else> {{ image.templateid }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Plant Folder</td>
                    <td>{{ image.plantfolder }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Plant ID</td>
                    <td>{{ image.plantid }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Site ID</td>
                    <td>{{ image.siteid }}</td>
                  </tr>
                  <tr>
                    <td>OS</td>
                    <td>{{ image.os }}</td>
                  </tr>
                  <tr>
                    <td>Devices</td>
                    <td>{{ image.deviceidxsList.length }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Device Models</td>
                    <td>{{ prettyList(image.devicemodelsList) }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Remote Management</td>
                    <td>{{ prettyBool(image.remotemanagement) }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Remote Access</td>
                    <td>{{ prettyBool(image.remoteaccess) }}</td>
                  </tr>
                  <tr v-if="image.remoteaccess">
                    <td style="white-space: nowrap">Remote Access Port</td>
                    <td>{{ image.remoteaccessport }}</td>
                  </tr>
                  <tr>
                    <td>Size</td>
                    <td> {{ prettyBytes(image.size) }}</td>
                  </tr>
                  <tr>
                    <td>ETag</td>
                    <td> {{ image.etag }}</td>
                  </tr>
                  <tr v-if="deviceTypeToString(image.type) == 'SCADA'">
                    <td style="white-space: nowrap">Unity Release</td>
                    <td>{{ image.unityrelease }}</td>
                  </tr>
                  <tr>
                    <td>Packages</td>
                    <td v-if="image.packageversionsList.length == 0">latest</td>
                    <td v-else>{{ prettyPackages(image.packageversionsList) }}</td>
                  </tr>
                  <tr>
                    <td>Status</td>
                    <td v-if='image.status == imageStatus().PENDING'><v-icon small color="info">hourglass_full</v-icon>PENDING</td>
                    <td v-else-if='image.status == imageStatus().RUNNING'><v-icon small color="info">hourglass_full</v-icon>RUNNING</td>
                    <td v-else-if='image.status == imageStatus().DONE'><v-icon small color="success">done</v-icon>DONE</td>
                    <td v-else-if='image.status == imageStatus().FAILED'><v-icon small color="error">error</v-icon>FAILED</td>
                    <td v-else-if='image.status == imageStatus().TIMEOUT'><v-icon small color="error">hourglass_empty</v-icon>TIMEOUT</td>
                  </tr>
                  <tr v-if="image.status == imageStatus().FAILED">
                    <td>Error</td>
                    <td>{{ image.error }}</td>
                  </tr>
                  <tr>
                    <td>Owner</td>
                    <td>{{ image.owner }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Last Modified</td>
                    <td>{{ dateToString(image.lastmodified) }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Modified By</td>
                    <td>{{ image.modifiedby }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-flex>

            <v-flex md6>
              <v-card>
                <v-card-text v-if="!image.invalid && image.status == imageStatus().DONE && image.deviceidxsList.length < image.devices">
                  <div style="color:red">
                    This image supports only {{ image.deviceidxsList.length }} of {{ image.devices }} devices for this plant!
                    <v-btn color="primary" x-small @click.prevent="showDeviceIDXs = true" :style="{cursor:'pointer'}" v-if='image.status == imageStatus().DONE'>Show Devices</v-btn>
                  </div>
                  <div>
                    If those devices are supported by another template, you can create additional images using supported templates.
                  </div>
                </v-card-text>

                <v-card-text v-if="!image.invalid">
                  Image is verified for changes in source before download begins, but you may also verify manually.
                  <v-btn color="primary" x-small @click.prevent="displayRootPassword(image.imageid)" :style="{cursor:'pointer'}" v-if='image.status == imageStatus().DONE && aaaaccess(user)'>Show Root Password</v-btn>
                </v-card-text>

                <v-card-text v-if="image.invalid">
                  <div style="color:red" v-if="image.invalid">
                    Image is invalidated and cannot be downloaded, please create a new image to download. <br />
                  </div>
                </v-card-text>

                <v-card-text>
                  Instructions for specific devices can be found on these links:
                  <ul>
                    <li v-for="v in image.devicemodelsList" :key="v">
                      <!-- <a :href="'/docs/#'+v.toLowerCase()" target="_blank">{{ v }}</a> -->
                      <a :href="'https://powerfactors.atlassian.net/wiki/spaces/ITSM/pages/2903837355/ImageMaker+User+Guide#ICO300'" target="_blank">{{ v }}</a>
                    </li>
                  </ul>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="showRootPassword"
      hide-overlay
      width="500"
    >
      <v-card>
        <v-card-title>Root Password</v-card-title>
        <v-card-text>
          <pre>{{ rootpassword }}</pre>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showRootPassword = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showDeviceIDXs"
      hide-overlay
      width="500"
      v-if="image"
    >
      <v-card>
        <v-card-title>Devices supported by this image</v-card-title>
        <v-card-text>
          <pre>{{ image.plantid }}-c[{{ prettyList(image.deviceidxsList) }}]</pre>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showDeviceIDXs = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="confirmDelete"
      width="500"
    >
      <v-card>
        <v-card-title>Delete selected image?</v-card-title>
        <v-card-text>
          "{{ imageid }}" will be deleted. You can't undo this action.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.prevent="confirmDelete = false">Cancel</v-btn>
          <v-btn color="primary" text @click.prevent="callDeleteImage(); confirmDelete = false">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog"
      persistent
      width="500"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackdownload"
      :color="snackColor"
      :timeout="-1"
      :top="true"
    >
      {{ snackMessage }}
      <v-btn
        text
        @click="abortDownloadImage(); snackdownload = false"
      >
        <div class="v-menu__content--active" style="display:none; z-index:1000;"></div>
        Cancel
      </v-btn>
    </v-snackbar>

    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTimeout"
      :top="true"
    >
      {{ snackMessage }}
      <v-btn
        text
        @click="snack = false"
      >
        <div class="v-menu__content--active" style="display:none; z-index:1000;"></div>
        Close
      </v-btn>
    </v-snackbar>

  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import auth from "@/auth/authService";
import config from '../../config/config.json';
import streamSaver from 'streamsaver'
import libvue from '@/lib/vue.js'

export default {
    mixins: [libvue],
    data() {
    return {
      baseurl: process.env.NODE_ENV == 'production' ? window.location.protocol + '//' + window.location.hostname : config.url,
      imageid: this.$route.params.ImageID,
      showRootPassword: false,
      showDeviceIDXs: false,
      rootpassword: null,
      confirmDelete: false,
      dialog: false,
      controller: null,
      signal: null,
      snack: false,
      snackColor: 'primary',
      snackMessage: '',
      snackTimeout: 1000,
      snackdownload: false
    }
  },
  components: {},
  mounted() {
  },
  created() {
    this.controller = new AbortController();
    this.signal = this.controller.signal;
  },
  computed: {
    image: {
      get() {
        return this.allImages[this.imageid];
      }
    },
    ...mapGetters(['allImages', 'user', 'isLoading'])
  },
  methods: {
    openImagesPage() {
      this.$router.push({ name: 'images' });
    },
    openTemplatePage(templateid) {
      this.$router.push({ name: 'template-details', params: {TemplateID: templateid} });
    },
    callDeleteImage() {
      this.dialog = true;
      var t = Object.assign({}, this.image);
      this.deleteImage(t).then(() => {
          this.dialog = false;
          this.snack = true;
          this.snackColor = 'success';
          this.snackMessage = "Image deleted";
          this.openImagesPage();
        }).catch(() => {
          this.dialog = false;
        });
    },
    callVerifyImage() {
      this.dialog = true;
      var t = Object.assign({}, this.image);
      this.verifyImage(t).then(() => {
          this.dialog = false;
          this.snack = true;
          this.snackColor = 'success';
          this.snackMessage = "Image verified";
        }).catch(() => {
          this.dialog = false;
        });
    },
    downloadImage() {
      this.dialog = true;
      var t = Object.assign({}, this.image);
      this.verifyImage(t).then(() => {
        this.dialog = false;
        this.snackdownload = true;
        this.snackColor = 'info'
        this.snackMessage = "Downloading file";
        auth.getAccessToken().then(accessToken => {
          var filename = this.image.plantid + "-" + this.deviceTypeToString(this.image.type);
          if (this.image.os == 'Debian 9 ARMEL' || this.image.os == 'Debian 9 ARMHF' || this.image.os == 'Debian 9 ARMHF WAGO' || this.image.os == 'Debian 11 ARM64') {
            filename += ".dd";
          } else {
            filename += ".iso";
          }
          const url = this.baseurl+'/_krafty1.1/download/'+this.imageid;
          const fileStream = streamSaver.createWriteStream(filename);
          const headers = new Headers();
          headers.append("Authorization", `Bearer ${accessToken}`);
          const request = new Request(url, {
            method: 'GET',
            headers: headers,
            mode: 'cors',
            cache: 'default',
            signal: this.signal,
          });
          fetch(request).then(res => {
            const readableStream = res.body

            // more optimized
            if (window.WritableStream && readableStream.pipeTo) {
              return readableStream.pipeTo(fileStream).then(() => {
                this.snackdownload = false;
              });
            }

            // abort so it dose not look stuck
            window.onunload = () => {
              window.WritableStream.abort()
            }

            // window.onbeforeunload = evt => {
            //   if (!done) {
            //     evt.returnValue = `Are you sure you want to leave?`;
            //   }
            // }

            // window.writer = fileStream.getWriter()

            // const reader = res.body.getReader()
            // const pump = () => reader.read()
            //   .then(res => res.done
            //     ? writer.close()
            //     : writer.write(res.value).then(pump))

            // pump()
          }).catch(err => {
            this.dialog = false;
            this.snack = true;
            this.snackColor = 'error'
            if (err.response && err.response.data != "") {
              this.snackMessage = err.response.data;
            } else {
              this.snackMessage = err;
            }
          });
        });
      }).catch(() => {
        this.dialog = false;
      });
    },
    abortDownloadImage() {
      this.controller.abort();
      this.controller = new AbortController();
      this.signal = this.controller.signal;
    },
    displayRootPassword(imageid) {
      this.getCredentials({imageid: imageid}).then((v) => {
        this.rootpassword = v.rootpassword;
        this.showRootPassword = true;
      }).catch(() => {
        this.rootpassword = "Credentials where not found or you do not have access";
        this.showRootPassword = true;
      });
    },
    displayDeviceIDXs(imageid) {
      this.getCredentials({imageid: imageid}).then((v) => {
        this.rootpassword = v.rootpassword;
        this.showRootPassword = true;
      }).catch(() => {
        this.rootpassword = "Credentials where not found or you do not have access";
        this.showRootPassword = true;
      });
    },
    getTypes() {
      var types = [];
      // eslint-disable-next-line no-undef
      types.push(this.deviceTypeToString(proto.pb.ImageType.DEVICECONTROLLER));
      // eslint-disable-next-line no-undef
      types.push(this.deviceTypeToString(proto.pb.ImageType.DEVICESCADA));
      return types;
    },
    ...mapActions(['deleteImage', 'verifyImage', 'getCredentials'])
  }
}
</script>
